module.exports = "<p>\r\n  User ID: {{user.Id}}\r\n</p>\r\n<div>\r\n  <label for=\"txtFirstName\">First Name:</label>\r\n  <input type=\"text\" id=\"txtFirstName\" [(ngModel)]=\"user.FirstName\" />\r\n</div>\r\n<div>\r\n  <label for=\"txtLastName\">Last Name:</label>\r\n  <input type=\"text\" id=\"txtLastName\" [(ngModel)]=\"user.LastName\" />\r\n</div>\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/user/user.component.html
// module id = ./src/app/components/user/user.component.html
// module chunks = main